import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { ZeeFontMedium, ZeeFontRegular } from 'src/styles/font';
import { MediaBP as MQ } from 'src/styles/mediaQuery';
export const description = (spaceY: string) => css`
  margin-top: ${spaceY}px;
  ${MQ.MobileXs} {
    ${ZeeFontRegular(12, 18)};
    color: ${colors.greyNeutral};
  }
  ${MQ.MediaSm} {
    ${ZeeFontMedium(14, 20)};
  }
  ${MQ.MediaMd} {
    ${ZeeFontMedium(14, 20)};
  }
  ${MQ.MediaXl} {
    ${ZeeFontMedium(16, 24)};
  }
`;
